export function toInteger(value: number): number {
  return Math.trunc(value);
}
